import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useState} from 'react';

import {GRAY_LIGHT} from 'ui-library/Colors';
import Modal from 'ui-library/modals/Modal';

import useSidebarDragState from './useSidebarDragState';
import WarehouseDiagramSidebar from './WarehouseDiagramSidebar';
import WarehouseDiagramWrapper from './WarehouseDiagramWrapper';

export interface WarehouseDiagramModalProps {
  schemaName: string;
  focusTableName: string;
  setDraftSQLQuery: (newDraftSQLQuery: string) => void;
  draftSQLQuery: string;
  onRequestClose: () => void;
}

export default function WarehouseDiagramModal(props: WarehouseDiagramModalProps): JSX.Element {
  const {sidebarWidth, resizing, sidebarResize, endSidebarResize, startSidebarResize} = useSidebarDragState();
  const [modalSQLQuery, setModalSQLQuery] = useState(props.draftSQLQuery);

  return (
    <div
      className={classNames('warehouse-diagram-modal-wrapper', css(resizing && styles.resizing))}
      onMouseMove={sidebarResize}
      onMouseUp={endSidebarResize}
    >
      <Modal
        fullWidth={true}
        fullHeight={true}
        closeableOnBackgroundClick={false}
        closeableOnEscapeKey={false}
        bodyPadded={false}
        onRequestClose={props.onRequestClose}
        title="Entity Relationship Diagram"
      >
        <div className={css(styles.diagramModalContentWrapper)}>
          <div className={css(styles.diagramContainer)}>
            <WarehouseDiagramWrapper schemaName={props.schemaName} focusTableName={props.focusTableName} />
          </div>
          <div className={css(styles.sidebarSeparator)} onMouseDown={startSidebarResize} />
          <div className={css(styles.sidebarContainer)} style={{width: `${sidebarWidth}px`}}>
            <WarehouseDiagramSidebar
              modalSQLQuery={modalSQLQuery}
              onModalSQLQueryChange={(newQuery: string): void => {
                props.setDraftSQLQuery(newQuery);
                setModalSQLQuery(newQuery);
              }}
              sidebarWidth={sidebarWidth}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

const styles = StyleSheet.create({
  diagramModalContentWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    overflow: 'hidden',
  },
  diagramContainer: {
    flexGrow: 1,
    zIndex: 0,
  },
  sidebarContainer: {
    height: '100%',
    overflowY: 'hidden',
    background: 'white',
    zIndex: 1,
  },
  sidebarSeparator: {
    borderLeft: `4px solid ${GRAY_LIGHT}`,
    cursor: 'col-resize',
    zIndex: 1,
  },
  resizing: {
    cursor: 'col-resize',
  },
});
